import React, { useEffect, useState, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify'; // <-- import toast
import 'react-toastify/dist/ReactToastify.css';
import DashboardLayout from './DashboardLayout';
import MemberManagement from './Members/Member';
import baseURL from '../../user/config';
import PageLoader from '../../../Reusable/PageLoader';

const Members = () => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    // Define the data fetching function
    const fetchMembersData = useCallback(async () => {
        try {
             //   await new Promise(resolve => setTimeout(resolve, 4000));

            const response = await fetch(`${baseURL}/org/members`, {
                method: 'GET',
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Failed to fetch members.');
            }

            const data = await response.json();
            setMembers(data.members);
        } catch (err) {
            toast.error(`Error fetching members: ${err.message}`); // <-- toast for errors
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMembersData();
    }, [fetchMembersData]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* loader inside layout */}

            {!loading && (
                <Box sx={{ p: 3 }}>
                    <Typography variant="h4" sx={{ mb: 4, mt: 2, fontWeight: 'bold' }}>
                        Members Dashboard
                    </Typography>
                    <MemberManagement members={members} refetchMembers={fetchMembersData} />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default Members;
